import { Chip } from "@mui/material";
import { colors } from "../../theme";

/**
 * Tinted pill for representing a status. Maps semantic keys to a calm
 * palette derived from the design tokens.
 *
 *   <StatusChip tone="success" label="Active" />
 *
 * Falls back to a neutral muted look if the tone is unknown so callers
 * never blow up on a new backend status string.
 */
const TONE_STYLES = {
  success: { bg: "#E6F6EA", fg: "#1B5E28", dot: colors.status.success },
  danger: { bg: "#FFECEB", fg: "#7A1E18", dot: colors.status.danger },
  warning: { bg: "#FFF1DB", fg: "#7A4A05", dot: colors.status.warning },
  info: { bg: colors.action.blueTint, fg: colors.action.blueHover, dot: colors.action.blue },
  brand: { bg: colors.brand.purpleTint, fg: colors.brand.purple, dot: colors.brand.purple },
  neutral: { bg: colors.bg.surfaceMuted, fg: colors.text.primary, dot: colors.text.secondary },
  muted: { bg: colors.bg.surfaceMuted, fg: colors.text.secondary, dot: colors.text.tertiary },
};

export default function StatusChip({
  tone = "neutral",
  label,
  dot = true,
  size = "small",
  sx,
  ...rest
}) {
  const palette = TONE_STYLES[tone] ?? TONE_STYLES.neutral;
  return (
    <Chip
      size={size}
      label={label}
      sx={{
        bgcolor: palette.bg,
        color: palette.fg,
        fontWeight: 600,
        border: 0,
        pl: dot ? 0.75 : undefined,
        "& .MuiChip-label": {
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          paddingInlineStart: dot ? 0 : undefined,
          "&::before": dot
            ? {
                content: '""',
                width: 6,
                height: 6,
                borderRadius: "50%",
                bgcolor: palette.dot,
                display: "inline-block",
                flexShrink: 0,
              }
            : undefined,
        },
        ...sx,
      }}
      {...rest}
    />
  );
}
